/* global intlData Handlebars moment reservationsApi */


var cart = null;

const removeFromCart = (e) => {
	e.preventDefault();
	let parent = e.target.parentElement;
	while (parent.tagName.toLowerCase() !== 'tbody') {
		parent = parent.parentElement;
	}
	parent.remove();
};

const renderPaymentBook = (row) => {
	const template = Handlebars.compile(document.querySelector('#tpl-payment-product').innerHTML);
	const productTable = document.querySelector('.product-table-js');
	const selectableAmount = [0,1,2,3,4,5,6,7,8,9,10,11,12];
	selectableAmount.shift();
	const book = row;
	book.selectableAmount = selectableAmount;
	const rendered = template(book, {
		data: { intl: intlData },
	});
	productTable.innerHTML += rendered;
};

const renderPaymentProduct = (row, participantInputs) => {
	var emailAddresses = Array.prototype.map.call(participantInputs, function(obj) {
		return obj.value;
	});
	const template = Handlebars.compile(document.querySelector('#tpl-payment-reservation').innerHTML);
	const selectableAmount = [0,1,2,3,4,5,6,7,8,9,10,11,12];
	selectableAmount.shift();
	const productTable = document.querySelector('.product-table-js');
	const product = row;
	const guests = [];
	// const guests = Array.from(Array(product.amount).keys());
	console.log(product);
	const startDate = moment(product.item.start_date);
	const endDate = moment(product.item.end_date);
	guests.shift();
	product.emailAddresses = emailAddresses;
	product.guests = guests;
	product.htmlFromDate = startDate.format('D MMM');
	product.htmlStartTime = startDate.format('HH:mm');
	product.htmlEndTime = endDate.format('HH:mm');
	product.selectableAmount = selectableAmount;
	product.mapped_study_material = product.study_material;
	// product.mapped_study_material = product.study_material.filter(function(material){
	// 	if(cart.books[material.id]){
	// 		return false
	// 	}
	// 	return true
	// }).map((material) => {
	// 	material.selectableAmount = selectableAmount;
	// 	return material;
	// });
	if (product.study_material){

		for(var key in product.study_material){
			var value = product.study_material[key];
			if (value.selected){
				product.item.name += ' + ' + value.name
			}
		}
	}

	const rendered = template(product, {
		data: { intl: intlData },
	});


	productTable.innerHTML += rendered;
};

const renderPaymentDiscount = (row) => {
	const template = Handlebars.compile(document.querySelector('#tpl-payment-discount').innerHTML);
	const discountList = document.querySelector('.discount-list-js');
	const discount = row;
	const rendered = template(discount);
	discountList.innerHTML += rendered;
};

const renderPaymentGiftcertificate = (row) => {
	const template = Handlebars.compile(document.querySelector('#tpl-payment-gift-certificate').innerHTML);
	const productTable = document.querySelector('.product-table-js');
	const giftcard = row;
	const rendered = template(giftcard);
	productTable.innerHTML += rendered;
};

const renderPaymentTotals = (totals) => {
	const paymentTotalsOverview = document.querySelector('.payment-totals-js');
	const template = Handlebars.compile(document.querySelector('#tpl-payment-totals').innerHTML);
	if (totals.raw_total_price !== 0) {
		totals.raw_total_price = parseFloat(totals.raw_total_price).toFixed(2).replace(".", ",");
	}
	if (totals.shippingcost !== 0) {
		totals.shippingcost = parseFloat(totals.shippingcost).toFixed(2).replace(".", ",");
	}
	if (totals.discounts !== 0) {
		totals.discounts = parseFloat(totals.discounts).toFixed(2).replace(".", ",");
	}
	if (totals.vouchers !== 0) {
		totals.vouchers = parseFloat(totals.vouchers).toFixed(2).replace(".", ",");
	}
	if (totals.total_price !== 0) {
		totals.total_price = parseFloat(totals.total_price).toFixed(2).replace(".", ",");
	}

	const rendered = template(totals);
	paymentTotalsOverview.innerHTML = rendered;
};

const renderGiftcardList = (vouchers, discounts) => {
	//Vouchers on step 3 now also needs to show the discounts
	const template = Handlebars.compile(document.querySelector('#tpl-payment-voucher').innerHTML);
	const discountList = document.querySelector('.voucher-list-js');
	discountList.innerHTML = '';
	if(vouchers){
		for(var key in vouchers){
			var value = vouchers[key];
			value.remove_id = value.code;
			const rendered = template(value);
			discountList.innerHTML += rendered;
		}
	}
	if(discounts){
		for(var dkey in discounts){
			var dvalue = discounts[dkey];
			dvalue.remove_id = dkey;
			const rendered = template(dvalue);
			discountList.innerHTML += rendered;
		}
	}

};

const togglePasswordFields = (show) => {
	if (!show) {
	    document.querySelector('#signup #payment_password_2').removeAttribute('disabled', '');
	    document.querySelector('#signup #payment_repeat_password_2').removeAttribute('disabled', '');
	    document.querySelector('#signup #payment_password_2').setAttribute('required', '');
	    document.querySelector('#signup #payment_repeat_password_2').setAttribute('required', '');
	} else {
	    document.querySelector('#signup #payment_password_2').removeAttribute('required');
	    document.querySelector('#signup #payment_repeat_password_2').removeAttribute('required');
	    document.querySelector('#signup #payment_password_2').setAttribute('disabled', '');
	    document.querySelector('#signup #payment_repeat_password_2').setAttribute('disabled', '');
	}
};

const renderPaymentStep = (data, url) => {
	cart = (data.cart !== undefined) ? data.cart : data;
	if (window.location.pathname.indexOf('winkelwagen') === -1) {
		window.location.replace('/winkelwagen/overzicht/');
	}

	if (document.querySelector('.product-table-js')) {
		var addedParticipants = Array.from(document.querySelectorAll('.participant-input-js'));

		const productTable = document.querySelector('.product-table-js');
		const header = productTable.firstElementChild !== null ? productTable.removeChild(productTable.firstElementChild) : null;
		productTable.innerHTML = '';


		for (var g in cart.giftcards){
			renderPaymentGiftcertificate(cart.giftcards[g]);
		}

		for (var p in cart.products){
			renderPaymentProduct(cart.products[p], addedParticipants);
		}

		for (var b in cart.books){
			renderPaymentBook(cart.books[b]);
		}

		if (header !== null) {
			productTable.innerHTML = header.outerHTML + productTable.innerHTML;
		}
	}

	if (document.querySelector('.voucher-list-js')) {
		if (url === 'cart/voucher/' && data.success === false) {
			document.querySelector('.voucher-error-js').style.display = 'block';
		} else {
			document.querySelector('.voucher-error-js').style.display = 'none';
		}
		renderGiftcardList(cart.vouchers, cart.discounts);
	}

	if (document.querySelector('.payment-totals-js')) {
		renderPaymentTotals(cart.totals);
	}

	if (document.querySelector('.discount-list-js')) {
		const discountList = document.querySelector('.discount-list-js');
		if (url === 'cart/discountcode/' && data.success === false) {
			document.querySelector('.discount-code-error-js').style.display = 'block';
		} else {
			document.querySelector('.discount-code-error-js').style.display = 'none';
		}
		discountList.innerHTML = '';

		renderGiftcardList(cart.vouchers, cart.discounts);

		// for(var d in cart.discounts){
		// 	renderPaymentDiscount(cart.discounts[d]);
		// }
	}

	if (data.cart_total !== undefined) {
		renderShoppingCartCount(data);
	}
};

const addDiscount = () => {
	const code = document.querySelector('.discount-input-js').value;
	reservationsApi.addDiscountCode({ discount_code: code }, renderPaymentStep);
};

const removeDiscount = (code) => {
	reservationsApi.removeDiscountCode(code, renderPaymentStep);
};

const removeVoucher = (code) => {
	reservationsApi.removeVoucher(code, renderPaymentStep);
};

const addVoucher = () => {
	const voucherCode = document.querySelector('.voucher-input-js').value;
	reservationsApi.addVoucher({ code: voucherCode }, renderPaymentStep);
};

if (document.querySelector('.discount-button-js')) {
	document.querySelector('.discount-button-js').addEventListener('click', (e) => {
		e.preventDefault();
		addDiscount();
	});
}

if (document.querySelector('.voucher-button-js')) {
	document.querySelector('.voucher-button-js').addEventListener('click', (e) => {
		e.preventDefault();
		addVoucher();
	});
}

if (document.querySelector('#id_disable_account_creation')) {
  	document.querySelector('#id_disable_account_creation').addEventListener('change', (e) => {
  		togglePasswordFields(e.target.checked);
	});
}

function jumpToEmail () {
	var emailField = document.querySelector('#onboarding_email');
	emailField.scrollIntoView({behavior: 'smooth'});
	emailField.focus();
}

function validateAccountForm () {
	console.log('validateAccountForm');
}

function setAddressValidation () {
	var postalCode = document.querySelector('.postal-code-js');
	var number = document.querySelector('.house-number-js');
	var street = document.querySelector('.street-js');
	var city = document.querySelector('.city-js');
	var otherAddress = document.querySelector('.other-address-js').checked;

	if (otherAddress) {
		postalCode.setAttribute('required', 'required');
		postalCode.parentElement.classList.add('form-group');

		number.setAttribute('required', 'required');
		number.parentElement.classList.add('form-group');

		street.setAttribute('required', 'required');
		street.parentElement.classList.add('form-group');

		city.setAttribute('required', 'required');
		city.parentElement.classList.add('form-group');
	} else {
		postalCode.removeAttribute('required', 'required');
		postalCode.parentElement.classList.remove('form-group');

		number.removeAttribute('required', 'required');
		number.parentElement.classList.remove('form-group');

		street.removeAttribute('required', 'required');
		street.parentElement.classList.remove('form-group');

		city.removeAttribute('required', 'required');
		city.parentElement.classList.remove('form-group');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	if (document.querySelector('.product-table-js')) {
		reservationsApi.fetchShoppingCart(renderPaymentStep);
	}
	if (document.querySelector('#id_disable_account_creation')) {
		togglePasswordFields(document.querySelector('#id_disable_account_creation').checked);
	}
});
